// src/components/Course/ModulesList.jsx
import React, {useState} from "react";
import { Link } from "react-router-dom";
import QuizModal from "./QuizeModel";

function ModulesList({
  modules,
  openModule,
  setOpenModule,
  activeVideo,
  onVideoSelect,
}) {


  
  const [showQuiz, setShowQuiz] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState([]);

  const startQuiz = (quizList) => {
    setSelectedQuiz(quizList);
    setShowQuiz(true);
  };
  return (
    <>

     {showQuiz && (
        <QuizModal
          quizzes={selectedQuiz}
          onClose={() => setShowQuiz(false)}
        />
      )}
    <div className="accordion course-accordion" id="courseAccordion">

      {modules.map((module) => (
        <div key={module.id} className="accordion-item mb-3">

          <h2 className="accordion-header">
            <button
              className={`accordion-button ${openModule !== module.id ? "collapsed" : ""}`}
              onClick={() => setOpenModule(openModule === module.id ? null : module.id)}
            >
              <div className="d-flex justify-content-between w-100">
                <span>{module.title}</span>
                <span className="text-muted small">
                  {module.videos.length} Videos
                </span>
              </div>
            </button>
          </h2>

          <div className={`accordion-collapse collapse ${openModule === module.id ? "show" : ""}`}>
            <div className="accordion-body p-0">

              {module.videos.map((v) => {
                const active = activeVideo?.id === v.id;

                return (
                  <div key={v.id} className="border-bottom">

                    {/* -------- Video Row ---------- */}
                    <div
                      className={`module-item d-flex justify-content-between align-items-center px-3 py-3 
                        ${active ? "active" : ""}`}
                      onClick={() => onVideoSelect(v)}
                      role="button"
                    >
                      <div className="d-flex align-items-center">
                        <i className="fa-regular fa-circle-play me-3"></i>

                        <div>
                          <div className="fw-medium">{v.title}</div>
                          {/* <div className="small text-muted">Available</div> */}
                        </div>
                      </div>

                      <span className="small text-muted">{v.duration}</span>
                    </div>

                    {/* -------- PDF & Quiz Buttons ---------- */}
                    <div className="px-3 pb-2 d-flex gap-2 mt-2">

                      {v.pdf && (
                        <Link 
                          to={v.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="th-btn style4"
                          style={{ padding: "9px 13px", fontSize: "15px" }}
                        >
                          <i className="fa-solid fa-file-pdf me-1"></i>
                             {v?.pdf_title}
                        </Link>
                      )}

                       {v.quizzes && v.quizzes.length > 0 && (
                          <button
                            className="th-btn style4"
                            style={{ padding: "9px 13px", fontSize: "12px" }}
                            onClick={() => startQuiz(v.quizzes)}
                          >
                            <i className="fa-solid fa-clipboard-check me-1"></i>
                              Start Quiz
                          </button>
                        )}
                    </div>


                  </div>
                );
              })}

            </div>
          </div>
        </div>
      ))}

    </div>
    
    
    </>
  );
}

export default ModulesList;
